module.exports = __webpack_public_path__ + "img/menu_btn.b8a7440b.png";